module.exports = __webpack_public_path__ + "static/media/potion.be4050d8.png";